import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9758302"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"24px","margin-bottom":"24px","margin-left":"10px"} }, " 印章证照刻制 ", -1))
const _hoisted_2 = { style: {"margin-left":"10px","border-bottom":"1px solid rgb(238, 238, 238)","padding-bottom":"24px"} }
const _hoisted_3 = { style: {"color":"#333"} }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import { sealLicenseChangeDetail } from "@/api/change_process";
import { PLAINOPTIONS } from "@/const/home";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false },
    traceId: { default: "" }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean, traceId: string }





watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
onMounted(async () => {
  getdata();
});
const GsDocumentCollection = ref<string>("");
watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);

const getdata = async () => {
  const { Data } = await sealLicenseChangeDetail({
    Id: props.folwId,
    TraceId: props.traceId,
  });
  GsDocumentCollection.value =
    Data?.Seals?.length &&
    Data?.Seals?.map((item: any) => {
      return item;
    }).join(", ");
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo: Data?.ApplicationInfo,
    ApplicationTime: Data?.ApplicationTime,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "变更资料审核",
      style: {"margin-top":"24px"}
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (GsDocumentCollection.value)
        ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
            key: 0,
            disabled: "",
            value: GsDocumentCollection.value.split(',')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(GsDocumentCollection.value.split(','), (item, index) => {
                return (_openBlock(), _createBlock(_component_a_checkbox, {
                  key: index,
                  class: _normalizeClass(index == 9 ? 'nomargin' : ''),
                  value: item.toString(),
                  label: item
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(PLAINOPTIONS)[item - 1]), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})